import MainServices from "@/services/mainService.js";
import vistaServices from "@/services/vistaServices.js";
import Vue from "vue";
import { groupBy } from "lodash";
import moment from "moment";
import store from "@/store";
import cloneDeep from "lodash/cloneDeep";
import rtsServices from "@/services/rtsServices";

function initialState() {
  return {
    schedule_details_obj: {},
    seoData: {},
    additionalCharges: [],
    prevSeatType: "",
    totalPrice: 0,
    totalGrossPrice: 0,
    screen: "",
    reservationId: "",
    seatsSelected: [],
    totalNumberOfSeats: 0,
    totalNumberOfSeatsCopy: 0,
    scheduleShowId: "",
    seatLayoutData: [],
    movie_data: [],
    seatLayout: [],
    times: [],
    output: [],
    currentRoute: null,
    movieDetailsFormatList: [],
    movieDetailsScheduleList: [],
    movieDetailsAllScheduleList: [],
    movieDetailsObject: {
      movie_id: null,
      lang_name: null,
      md_thumbnail_url: null,
      mt_link: null,
      mf_name: null,
      genre: null,
      mc_plot: null,
      mc_title: null,
      mrrdr_release_date: null,
      rating: null,
      mrrdr_runtime: null,
      movie_cast_crew: null,
      movie_production: []
    },
    langfilter: [],
    mf_filter: [],
    singleMovieDates: [],
    selectedDate: moment().format("DD-MM-YYYY"),
    movie_id: null,
    selectedMovieFilter: {
      showDate: null,
      showFormat: "ALL FORMATS"
    },
    selectedMovieFormat: {},
    offerApplied: null,
    totalTicketPrice: 0,
    selectedOffers: null,
    offerFor: null,
    offerPrice: 0,
    promocode: "",
    OffersList: [],
    offerCategoriesList: [],
    offerSet: false,
    seatGroupAll: [],
    seatGroupByType: [],
    totalAmount: 0,
    cashInput: 0,
    netAmount: 0,
    totalCashCollected: 0,
    totalCardAmount: 0,
    isCompleteRateCard: true,
    vouchers_data: [],
    newSeatLayoutArrayState: [],
    // applied_voucher: null,
    movie_dates: [],
    are_shows_available: true,
    isMultiSelectAllowed: false

  };
}
const state = initialState();

const mutations = {
  SET_ARE_SHOWS_AVAILABLE: (state, payload) => (state.are_shows_available = payload),
  SET_TEMP_LIKE: state => (state.movieDetailsObject.like_id = true),
  RESET_TEMP_LIKE: state => (state.movieDetailsObject.like_id = false),
  SET_COMPLETE_RATE_CARD: (state, payload) => {
    state.isCompleteRateCard = payload;
  },
  SET_SEAT_GROUP_ALL: (state, payload) => {
    state.seatGroupAll = payload;
  },
  SET_TOTAL_BOX_OFFICE_AMOUNT: (state, payload) => {
    state.totalAmount = payload.totalAmount;
    state.netAmount = payload.netAmount;
    state.totalTicketPrice = payload.totalAmount;
  },
  REMOVE_PROMO_CODE: (state, payload) => {
    state.totalTicketPrice += state.offerPrice;
    state.offerPrice = 0;
    state.offerSet = false;
    state.promocode = "";
    state.selectedOffers = null;
    state.offerFor = null;
  },
  SET_CURRENT_ROUTE: (state, payload) => {
    state.currentRoute = payload;
  },
  SET_ON_MOVIE_DETAILS: (state, payload) => {
    let Obj = {
      movie_id: state.movieDetailsObject.movie_id,
      lang_name: null,
      md_thumbnail_url: null,
      mt_link: null,
      mf_name: null,
      genre: null,
      mc_plot: null,
      mc_title: null,
      mrrdr_release_date: null,
      rating: null,
      mrrdr_runtime: null,
      movie_cast_crew: null,
      movie_production: []
    };
    state.movieDetailsObject = {
      ...Obj,
      ...payload
    };
    state.selectedMovieFilter.showFormat = "ALL FORMATS";
  },
  SET_ON_MOVIE_DETAILS_ID: (state, payload) => {
    state.movieDetailsObject.movie_id = payload.movie_id;
  },
  SET_ON_MOVIE_FILTERS: (state, payload) => {
    state.selectedMovieFilter[payload.name] = payload.value;
    state.selectedDate = payload.name == "showDate" ? payload.value : moment().format("DD-YY-MM");
    state.totalNumberOfSeats = state.totalNumberOfSeatsCopy;
  },
  SET_ON_MOVIE_FORMAT: (state, payload) => {
    state.movieDetailsFormatList = payload;
  },
  SET_ON_MOVIE_SCHEDULE: (state, payload) => {
    state.movieDetailsScheduleList = _.chain(payload)
      .groupBy("cinename_movie_format")
      .toPairs()
      .map(function (currentItem) {
        return _.fromPairs(_.zip(["cinename_movie_format", "ItemsList"], currentItem));
      })
      .value();

    if (state.movieDetailsScheduleList && state.movieDetailsScheduleList.length > 0) {
      state.movieDetailsScheduleList.map(x => {
        if (x["ItemsList"].length > 0 && x["ItemsList"]) {
          x["ItemsList"].map(y => {
            let start_show_time = moment(
              `${y.ss_start_date} ${y.ss_start_show_time}`,
              "YYYY-MM-DD HH:mm:ss"
            ).format("YYYY-MM-DD HH:mm:ss");
            let curent_time = moment().format("YYYY-MM-DD HH:mm:ss");
            if (moment(start_show_time).isBefore(moment(curent_time))) {
              y["status"] = true;
              x["status"] = true;
            } else {
              y["status"] = false;
              x["status"] = false;
            }
          });
        }
      });
    }
  },
  SET_ON_ALL_MOVIE_SCHEDULE: (state, payload) => {
    state.movieDetailsAllScheduleList.concat(payload);
  },
  GET_LANG_FILTER: (state, payload) => {
    state.langfilter.push(payload);
  },
  GET_MF_FILTER: (state, payload) => {
    state.mf_filter.push(payload);
  },
  RESET_LANG_MF: state => {
    (state.langfilter = []), (state.mf_filter = []);
  },

  SET_DATES: (state, payload) => {
    state.singleMovieDates = [];
    payload.map(x => {
      let date = x["ss_start_date"] ? moment(x.ss_start_date).format("DD-MM-YYYY") : "-";
      if (state.singleMovieDates.indexOf(date) == -1) {
        state.singleMovieDates.push(date);
      }
      return x;
    });
  },
  SET_MOVIE_DATES: (state, payload) => (state.movie_dates = payload),
  SET_MOVIE_ID: (state, payload) => (state.movie_id = payload),
  RESET_DATES: state => {
    state.singleMovieDates = [];
    state.selectedMovieFilter.showDate = null;
    state.movieDetailsScheduleList = null;
    state.movieDetailsFormatList = null;
  },
  SET_SEATS: (state, payload) => {
    state.seatLayoutData = payload.seats.seatLayoutNew;

  },

  RESET_ALL: state => {
    (state.movieDetailsScheduleList = []),
      (state.seatLayoutData = []),
      (state.seatsSelected = []),
      (state.totalNumberOfSeats = 0),
      (state.totalPrice = 0),
      (state.totalGrossPrice = 0);
    (state.additionalCharges = []),
      (state.totalTicketPrice = 0),
      (state.offerPrice = 0),
      (state.offerSet = false);
    state.promocode = "";
  },

  RESET_SEAT_DATA: state => {
    state.seatLayoutData = [];
    state.seatsSelected = [];
    state.totalNumberOfSeats = 0;
    state.totalNumberOfSeatsCopy = 0;
    state.totalPrice = 0;
    state.totalGrossPrice = 0;
    state.additionalCharges = [];
    state.totalTicketPrice = 0;
    state.offerPrice = 0;
    state.offerSet = false;
    state.promocode = "";

  },
  NUMBER_OF_SEATS: (state, payload) => {
    state.totalNumberOfSeats = payload;
    state.totalNumberOfSeatsCopy = payload;
    state.seatsSelected.map(x => {
      state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][
        x.seatIndex
      ].selectStatus = false;
      state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][
        x.seatIndex
      ].SelectStatusFlag = false;
    });
    state.prevSeatType = "";
    state.seatsSelected = [];
    state.totalPrice = 0;
    state.totalGrossPrice = 0;
    (state.totalTicketPrice = 0), (state.offerPrice = 0);
    state.offerSet = false;
    state.promocode = "";
  },

  SELECTED_SEATS: (state, payload) => {
    let globalOptions = store.getters.getGlobalOptions;

    if (!state.isMultiSelectAllowed) {
      state.prevSeatType = payload.classIndex;
      state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][
        payload.seatIndex
      ].selectStatus = !state.seatLayoutData[payload.classIndex].seatsFinal[
        payload.rowIndex
      ][payload.seatIndex].selectStatus;

      let seatStatus =
        state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][
          payload.seatIndex
        ].selectStatus;
    }

    if (
      state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][
        payload.seatIndex
      ].selectStatus == false
    ) {
      if (state.seatsSelected.length > 0) {
        state.seatsSelected.splice(state.seatsSelected.indexOf(payload.seat), 1)
      }
      state.totalAmount = 0;
      state.netAmount = 0;
      state.seatsSelected.map(x => {
        state.totalAmount = state.totalAmount + x.seat_price;
        state.netAmount = state.netAmount + x.seat_net_price;
      });

    }
    if (
      state.seatLayoutData[payload.classIndex].seatsFinal[payload.rowIndex][
        payload.seatIndex
      ].selectStatus == true
    ) {
      if (payload.seat.is_booked == "Y") {
        payload.seat.seat_price = 0.0;
        payload.seat.seat_net_price = 0.0;
        if (!state.isMultiSelectAllowed) {
          payload.seat["seatIndex"] = payload.seatIndex;
          payload.seat["rowIndex"] = payload.rowIndex;
          payload.seat["classIndex"] = payload.classIndex;
          state.seatsSelected.push(payload.seat);
        }
        state.netAmount = 0;
        state.totalAmount = 0;
        state.seatsSelected.map(x => {
          state.netAmount = 0.0;
          state.totalAmount = 0.0;
        });
      } else {
        if (!state.isMultiSelectAllowed) {
          payload.seat["seatIndex"] = payload.seatIndex;
          payload.seat["rowIndex"] = payload.rowIndex;
          payload.seat["classIndex"] = payload.classIndex;
          state.seatsSelected.push(payload.seat);
        }
        // state.seatsSelected.push(payload.seat)
        state.netAmount = 0;
        state.totalAmount = 0;
        state.seatsSelected.map(x => {
          state.netAmount = state.netAmount + x.seat_net_price;
          state.totalAmount = state.totalAmount + x.seat_price;
        });
      }
    }
    let seatsArray = "";
    for (let i in state.seatsSelected) {
      seatsArray += " " + state.seatsSelected[i].sl_seat_name;
    }
    // store.dispatch("onSetAndSendLog", {
    //   action: `Selected seats are : ${seatsArray} `,
    //   page_name: "pos booking",
    //   api_name: ""
    // });

  },
  __SELECT_SEAT_HANDLDER: (state, payload) => {
    let { seat, rowIndex, seatIndex, originalIndex, backward, e, type, scheduleShowId } = payload;
    handlerSeatSelected(seat, rowIndex, seatIndex, originalIndex, backward, e, type);
    function handlerSeatSelected(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
      let firstTime = 0;
      if (!originalIndex) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (state.totalNumberOfSeats != state.seatsSelected.length) {
        state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
      }
      if (state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus == false) {
        if (state.totalNumberOfSeats != state.seatsSelected.length) {
          state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
        }
      }

      if (state.totalNumberOfSeats == state.seatsSelected.length && firstTime == 1) {
        //deselect all
        state.seatsSelected.map(x => {
          if (x.sst_id != seat.sst_id) {
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][
              x.seatIndex
            ].selectStatus = false;
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][
              x.seatIndex
            ].SelectStatusFlag = false;
          } else {
            state.seatLayoutData[type].seatsFinal[x.rowIndex][x.seatIndex].selectStatus = false;
            state.seatLayoutData[type].seatsFinal[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
          }
        });
      }

      if (state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]["SelectStatusFlag"] == false) {
        //check if seat is selected, if yes, do nothing else
        //check how many selected
        if (parseInt(state.totalNumberOfSeats) - state.seatsSelected.length > 0) {
          state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]["SelectStatusFlag"] = true;
          state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex].selectStatus = true;
          seat.seatIndex = seatIndex;
          seat.rowIndex = rowIndex;
          state.prevSeatType = type;
          state.seatsSelected.push(seat);
          seatIndex + 1;
          //check on right if available, if yes, select
          if (
            state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1] &&
            backward != "backward" &&
            (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1]
              .seat_reserve_type_id == 1 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1]
                .seat_reserve_type_id == 11 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1]
                .seat_reserve_type_id == 5)
          ) {
            handlerSeatSelected(
              state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex) + 1],
              rowIndex,
              seatIndex + 1,
              originalIndex,
              backward,
              e,
              type
            );

            //check on left if available, if yes, select
          } else if (
            state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1] &&
            (state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1]
              .seat_reserve_type_id == 1 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1]
                .seat_reserve_type_id == 11 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1]
                .seat_reserve_type_id == 5)
          ) {
            handlerSeatSelected(
              state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(originalIndex) - 1],
              rowIndex,
              originalIndex - 1,
              originalIndex - 1,
              "backward",
              e,
              type
            );
          }
        } else {
          if (firstTime == 1) {
            state.seatsSelected = [];
            handlerSeatSelected(
              state.seatLayoutData[type].seatsFinal[rowIndex][parseInt(seatIndex)],
              rowIndex,
              seatIndex,
              originalIndex,
              null,
              e,
              type
            );
          }
        }
      }
    }
  },
  SELECT_SEAT_HANDLDER: (state, payload) => {
    let {
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type,
      scheduleShowId
    } = payload;

    let oldSelectedSeats = _.cloneDeep(state.seatsSelected);

    handlerSeatSelected(
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    );
    function handlerSeatSelected(
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    ) {
      let firstTime = 0;

      if (!originalIndex && originalIndex != 0) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (state.totalNumberOfSeats != state.seatsSelected.length) {
        state.seatLayoutData[type].seatsFinal[rowIndex][
          seatIndex
        ].selectStatus = true;
      }
      if (
        state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex]
          .selectStatus == false
      ) {
        if (state.totalNumberOfSeats != state.seatsSelected.length) {
          state.seatLayoutData[type].seatsFinal[rowIndex][
            seatIndex
          ].selectStatus = true;
        }
      }
      if (
        state.totalNumberOfSeats == state.seatsSelected.length &&
        firstTime == 1
      ) {
        state.seatsSelected.map(x => {
          if (x.sst_id != seat.sst_id) {
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][
              x.seatIndex
            ].selectStatus = false;
            state.seatLayoutData[state.prevSeatType].seatsFinal[x.rowIndex][
              x.seatIndex
            ].SelectStatusFlag = false;
          } else {
            state.seatLayoutData[type].seatsFinal[x.rowIndex][
              x.seatIndex
            ].selectStatus = false;
            state.seatLayoutData[type].seatsFinal[x.rowIndex][
              x.seatIndex
            ].SelectStatusFlag = false;
          }
        });

        state.seatLayoutData.map((zw, index) => {
          if (index != type) {
            zw.seatsFinal.map(diss => {
              diss.map(sl => {
                sl.selectStatus = false;
                sl.SelectStatusFlag = false;
              });
            });
          }
        });
        // state.seatsSelected = [];
      }

      if (
        state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex][
        "SelectStatusFlag"
        ] == false
      ) {
        //check if seat is selected, if yes, do nothing else
        //check how many selected
        if (
          parseInt(state.totalNumberOfSeats) - state.seatsSelected.length >
          0
        ) {
          if (seat.sl_seat_name != "") {
            state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex][
              "SelectStatusFlag"
            ] = true;
            state.seatLayoutData[type].seatsFinal[rowIndex][
              seatIndex
            ].selectStatus = true;
            seat.seatIndex = seatIndex;
            seat.rowIndex = rowIndex;
            seat.classIndex = type;
            state.prevSeatType = type;
            state.seatsSelected.push(seat);
            seatIndex + 1;
          } else {
            state.seatLayoutData[type].seatsFinal[rowIndex][seatIndex][
              "SelectStatusFlag"
            ] = false;
            state.seatLayoutData[type].seatsFinal[rowIndex][
              seatIndex
            ].selectStatus = false;
          }
          //check on right if available, if yes, select
          if (
            state.seatLayoutData[type].seatsFinal[rowIndex][
            parseInt(seatIndex) + 1
            ] &&
            backward != "backward" &&
            (state.seatLayoutData[type].seatsFinal[rowIndex][
              parseInt(seatIndex) + 1
            ].seat_reserve_type_id == 1 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][
                parseInt(seatIndex) + 1
              ].seat_reserve_type_id == 11 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][
                parseInt(seatIndex) + 1
              ].seat_reserve_type_id == 5 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][
                parseInt(originalIndex) + 1
              ].seat_reserve_type_id == 3)
          ) {
            //                        state.seatsSelected.push(seat);
            //                        state.seatData.SeatLayouts[classIndex].Seats[rowIndex][parseInt(seatIndex) + 1].SelectStatus = true;
            handlerSeatSelected(
              state.seatLayoutData[type].seatsFinal[rowIndex][
              parseInt(seatIndex) + 1
              ],
              rowIndex,
              seatIndex + 1,
              originalIndex,
              backward,
              e,
              type
            );

            //check on left if available, if yes, select
          } else if (
            state.seatLayoutData[type].seatsFinal[rowIndex][
            parseInt(originalIndex) - 1
            ] &&
            (state.seatLayoutData[type].seatsFinal[rowIndex][
              parseInt(originalIndex) - 1
            ].seat_reserve_type_id == 1 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][
                parseInt(originalIndex) - 1
              ].seat_reserve_type_id == 11 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][
                parseInt(originalIndex) - 1
              ].seat_reserve_type_id == 5 ||
              state.seatLayoutData[type].seatsFinal[rowIndex][
                parseInt(originalIndex) - 1
              ].seat_reserve_type_id == 3)
          ) {
            //                        state.seatsSelected.push(seat);
            //                        state.seatData.SeatLayouts[classIndex].Seats[rowIndex][parseInt(originalIndex) - 1].SelectStatus = true;
            handlerSeatSelected(
              state.seatLayoutData[type].seatsFinal[rowIndex][
              parseInt(originalIndex) - 1
              ],
              rowIndex,
              originalIndex - 1,
              originalIndex - 1,
              "backward",
              e,
              type
            );
          }
        } else {
          if (firstTime == 1) {
            state.seatsSelected = [];
            handlerSeatSelected(
              state.seatLayoutData[type].seatsFinal[rowIndex][
              parseInt(seatIndex)
              ],
              rowIndex,
              seatIndex,
              originalIndex,
              null,
              e,
              type
            );
          }
        }
      }
    }

    let newSelectedSeats = _.cloneDeep(state.seatsSelected);

    let removedSeats = [];
    let newAddedSeats = [];

    for (let oldSeat of oldSelectedSeats) {
      let index = newSelectedSeats.findIndex(x => x.sl_id == oldSeat.sl_id);
      if (index === -1) {
        removedSeats.push(oldSeat);
      }
    }

    for (let newSeat of newSelectedSeats) {
      let index = oldSelectedSeats.findIndex(x => x.sl_id == newSeat.sl_id);
      if (index === -1) {
        newAddedSeats.push(newSeat);
      }
    }

    removedSeats.map(seat => {
      store.dispatch("sendSeatToSocket", {
        select: false,
        seat
      });
    });

    newAddedSeats.map(seat => {
      store.dispatch("sendSeatToSocket", {
        select: true,
        seat
      });
    });

    let vipSeatArray = state.seatsSelected.filter(x => {
      return x.seat_reserve_type_id == 5 || x.seat_reserve_type_id == 12;
    });
    if (vipSeatArray.length > 0) {
      state.isVipSeatSelected = true;
    } else {
      state.isVipSeatSelected = false;
    }
  },
  ON_RESERVE_SEATS: (state, payload) => {
    state.reservationId = payload;
  },
  SET_SCREEN: (state, payload) => {
    state.screen = payload;
  },
  TOTAL_PRICE: (state, payload) => {
    state.totalPrice = payload.totalPrice;
    state.totalGrossPrice = payload.totalGrossPrice;
    state.totalTicketPrice = payload.totalGrossPrice;
  },
  SET_ADDITIONAL_CHARGES: (state, payload) => {
    state.additionalCharges = _.sortBy(payload.Additional_Charges, ["charge_type_id"]);
  },
  SET_SELECTED_OFFERS: (state, { offer, offerFor }) => {
    let is_on_net_amount;
    let is_offer_for;
    let is_on_gross_amount;

    if (offerFor === "offersAndPromotions") {
      is_on_net_amount = offer.offer_applicable_on_net_amount;
      is_offer_for = "offersAndPromotions";
      is_on_gross_amount = offer.offer_applicable_on_gross_amount;
    } else if (offerFor === "voucher") {
      is_on_net_amount = offer.voucher_redeem_on_net;
      is_offer_for = "vouchers";
      is_on_gross_amount = offer.voucher_redeem_on_gross;
    }

    state.selectedOffers = {
      ...offer,
      is_on_net_amount,
      is_offer_for,
      is_offer_applied: true,
      is_on_gross_amount
    };

    state.offerFor = offerFor;
  },
  CALCULATE_OFFER_PRICE: (state, { offer, offerFor }) => {
    // state.offerApplied = payload;
    let payload = offer;
    if (offerFor === "offersAndPromotions") {
      if (state.totalTicketPrice >= payload.pcs_min_ticket_amount) {
        if (payload.offer_applicable_on_gross_amount == "Y") {
          if (payload.offer_type_id == 6) {
            if (payload.pcs_offer_value) {
              if (payload.pcs_offer_value_is_percentage == "N") {
                state.offerPrice = parseFloat(payload.pcs_offer_value);
              } else if (payload.pcs_offer_value_is_percentage == "Y") {
                state.offerPrice =
                  (parseFloat(state.totalTicketPrice) * parseInt(payload.pcs_offer_value)) / 100;
                if (state.offerPrice > payload.pcs_max_discount_amount) {
                  state.offerPrice = payload.pcs_max_discount_amount;
                }
              }
            }
          } else if (payload.offer_type_id == 4) {
            if (store.getters.TOTAL_AMOUNT > payload.cco_min_ticket_amount) {
              if (payload.cco_offer_value) {
                if (payload.cco_offer_value_is_percentage == "N") {
                  state.offerPrice = parseFloat(payload.cco_offer_value);
                } else if (payload.cco_offer_value_is_percentage == "Y") {
                  state.offerPrice =
                    (parseFloat(store.getters.TOTAL_AMOUNT) * parseInt(payload.cco_offer_value)) /
                    100;
                }
                if (state.offerPrice > payload.cco_max_discount_amount) {
                  state.offerPrice = payload.cco_max_discount_amount;
                }
              }
            } else {
              Vue.toasted.show(
                `Minimum amount should be greater than ${payload.cco_min_ticket_amount}`
              );
            }
          } else if (payload.offer_type_id == 5) {
            if (payload.bo_offer_value) {
              if (payload.bo_offer_value_is_percentage == "Y") {
                state.offerPrice =
                  (parseFloat(store.getters.TOTAL_AMOUNT) * parseInt(payload.bo_offer_value)) / 100;
              } else {
                state.offerPrice = payload.bo_offer_value;
              }
            }
          } else {
            if (payload.oc_get_free_ticket) {
              const defaultRateCardTicketAmount = store.getters.SELECTED_SEATS[0].rate_card_group.find(
                rateCard => rateCard.default_rate_card === "Y"
              );
              const ticket_price = parseFloat(defaultRateCardTicketAmount.rc_amount);
              let maxNumberOfApplicableTickets;
              let totalNumberOfApplicableTickets = Math.floor(
                store.getters.SELECTED_SEATS.length /
                (payload.oc_buy_no_of_ticket + payload.oc_get_free_ticket)
              );
              totalNumberOfApplicableTickets *= payload.oc_get_free_ticket;
              if (
                totalNumberOfApplicableTickets >
                parseInt(payload.oc_max_no_of_ticket_per_transaction)
              ) {
                maxNumberOfApplicableTickets = parseInt(
                  payload.oc_max_no_of_ticket_per_transaction
                );
              } else {
                maxNumberOfApplicableTickets = totalNumberOfApplicableTickets;
              }
              state.offerPrice = ticket_price * maxNumberOfApplicableTickets;
            } else if (payload.oc_discount_value) {
              if (payload.oc_discount_value_is_percentage == "N") {
                let totalNumberOfApplicableTickets = Math.floor(
                  store.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket
                );
                state.offerPrice =
                  parseFloat(payload.oc_discount_value) * totalNumberOfApplicableTickets;
              } else if (payload.oc_discount_value_is_percentage == "Y") {
                let totalNumberOfApplicableTickets = Math.floor(
                  store.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket
                );
                state.offerPrice =
                  ((parseFloat(store.getters.TOTAL_AMOUNT) * parseInt(payload.oc_discount_value)) /
                    100) *
                  totalNumberOfApplicableTickets;
              }
            }
          }
        }
        //For Net Amount
        else if (payload.offer_applicable_on_net_amount == "Y") {
          if (payload.offer_type_id == 6) {
            if (payload.pcs_offer_value) {
              if (payload.pcs_offer_value_is_percentage == "N") {
                state.offerPrice = parseFloat(payload.pcs_offer_value);
              } else if (payload.pcs_offer_value_is_percentage == "Y") {
                state.offerPrice =
                  (parseFloat(store.getters.NET_AMOUNT) * parseInt(payload.pcs_offer_value)) / 100;
              }
            }
          } else if (payload.offer_type_id == 4) {
            if (store.getters.NET_AMOUNT > payload.cco_min_ticket_amount) {
              if (payload.cco_offer_value) {
                if (payload.cco_offer_value_is_percentage == "N") {
                  state.offerPrice = parseFloat(payload.cco_offer_value);
                } else if (payload.cco_offer_value_is_percentage == "Y") {
                  state.offerPrice =
                    (parseFloat(store.getters.NET_AMOUNT) * parseInt(payload.cco_offer_value)) /
                    100;
                }
                if (state.offerPrice > payload.cco_max_discount_amount) {
                  state.offerPrice = payload.cco_max_discount_amount;
                }
              }
            } else {
              Vue.toasted.show(
                `Minimum amount should be greater than ${payload.cco_min_ticket_amount}`
              );
            }
          } else {
            if (payload.oc_get_free_ticket) {
              state.offerPrice =
                parseFloat(store.getters.SELECTED_SEATS[0].seat_net_price) *
                payload.oc_get_free_ticket;
            } else if (payload.oc_discount_value) {
              if (payload.oc_discount_value_is_percentage == "N") {
                state.offerPrice = parseFloat(payload.oc_discount_value);
              } else if (payload.oc_discount_value_is_percentage == "Y") {
                state.offerPrice =
                  (parseFloat(store.getters.NET_AMOUNT) * parseInt(payload.oc_discount_value)) /
                  100;
              }
            }
          }
        }
        // Ensuring offer amount is not greater than max discount amount
        if (
          payload.oc_max_discount_amount &&
          state.offerPrice > payload.oc_max_discount_amount &&
          payload.oc_discount_value_is_percentage == "N"
        ) {
          state.offerPrice = payload.oc_max_discount_amount;
        }
        if (payload.oc_max_discount_amount && payload.oc_discount_value_is_percentage == "Y") {
          let totalNumberOfApplicableTickets = Math.floor(
            store.getters.SELECTED_SEATS.length / payload.oc_buy_no_of_ticket
          );
          let maxDiscountPercentage = totalNumberOfApplicableTickets * payload.oc_discount_value;
          if (maxDiscountPercentage > payload.oc_max_discount_amount) {
            if (payload.offer_applicable_on_net_amount == "Y") {
              state.offerPrice =
                (parseFloat(store.getters.NET_AMOUNT) * parseInt(payload.oc_max_discount_amount)) /
                100;
            } else if (payload.offer_applicable_on_gross_amount == "Y") {
              state.offerPrice =
                (parseFloat(store.getters.TOTAL_AMOUNT) *
                  parseInt(payload.oc_max_discount_amount)) /
                100;
            }
          }
        }
        if (payload.oc_max_discount_amount && state.offerPrice > payload.oc_max_discount_amount) {
          state.offerPrice = payload.oc_max_discount_amount;
        }
        state.totalTicketPrice -= state.offerPrice;
        state.offerSet = true;

        state.selectedOffers.t_offer_price = state.offerPrice;
        state.selectedOffers.oc_discount_value = state.offerPrice;
      } else {
        Vue.toasted.show("Transaction Amount does not qualify for discount");
      }
    } else if (offerFor === "voucher") {
      let voucherObj = offer;
      let voucherDiscount = 0;
      if (voucherObj.voucher_is_percentage === "Y") {
        voucherDiscount =
          voucherObj.voucher_redeem_on_gross === "Y"
            ? (voucherObj.voucher_amount / 100) * state.totalTicketPrice
            : voucherObj.voucher_redeem_on_net === "Y"
              ? (voucherObj.voucher_amount / 100) * state.netAmount
              : 0;
      } else {
        voucherDiscount = voucherObj.voucher_amount;
      }

      if (voucherDiscount > voucherObj.voucher_max_redemption_amount) {
        voucherDiscount = voucherObj.voucher_max_redemption_amount;
      } else if (voucherDiscount < voucherObj.voucher_min_redemption_amount) {
        voucherDiscount = voucherObj.voucher_min_redemption_amount;
      }

      state.offerPrice = voucherDiscount;
      state.totalTicketPrice -= state.offerPrice;
      state.offerSet = true;

      state.selectedOffers.t_offer_price = state.offerPrice;
      state.selectedOffers.oc_discount_value = state.offerPrice;
    }
  },
  SET_ENTER_PROMO_CODE: (state, payload) => {
    switch (payload.name) {
      case "enterPromoCode":
        state.promocode = payload.event.target.value;

        break;
      default:
    }
  },
  SET_OFFERS_LIST: (state, payload) => {
    state.OffersList = payload;

    state.OffersList.map(x => {
      if (String(x.offer_type_id) === "6") {
        let list =
          x["booking_user_category_id"] && x["booking_user_category_id"].length > 0
            ? x["booking_user_category_id"].split(", ")
            : [];
        x["booking_user_category_id"] = "";
        list.map(z => {
          let a = state.offerCategoriesList.filter(y => String(z) === String(y.buc_id));
          if (a.length > 0) {
            x["booking_user_category_id"] +=
              x["booking_user_category_id"].length > 0
                ? `, ${a[0].buc_category_name}`
                : `${a[0].buc_category_name}`;
          }
        });
      }
    });
  },
  SET_OFFERS_CATEGORIES_LIST: (state, payload) => {
    state.offerCategoriesList = payload;
  },
  ON_RESET_SELECTET_OFFER_AND_PRICE: (state, payload) => {
    state.offerPrice = 0;
    state.selectedOffers = {};
    state.promocode = "";
  },
  SET_SEO_DATA: (state, payload) => {
    state.seoData = payload;
  },
  SET_SCHEDULE_DETAILS_OBJ: (state, payload) => {
    state.schedule_details_obj = payload;
  },
  SET_SCHEDULE_OBJ: (state, payload) => {
    state.schedule_details_obj =
      state.movieDetailsScheduleList[payload.index1].ItemsList[payload.index2];
  },
  RESET_MOVIE_DETAILS_SCHEDULE_LIST: state => {
    state.movieDetailsScheduleList = [];
  },
  RESET_MOVIE_DETAILS_SCHEDULE_LIST_NEW: state => {
    state.movieDetailsFormatList = [];
    state.movieDetailsScheduleList = [];
    state.movieDetailsAllScheduleList = [];
    state.movieDetailsObject = {
      movie_id: null,
      lang_name: null,
      md_thumbnail_url: null,
      mt_link: null,
      mf_name: null,
      genre: null,
      mc_plot: null,
      mc_title: null,
      mrrdr_release_date: null,
      rating: null,
      mrrdr_runtime: null,
      movie_cast_crew: null,
      movie_production: []
    };
    state.offerPrice = null;
    state.totalPrice = 0;
    state.totalGrossPrice = 0;
    state.totalTicketPrice = 0;
  },
  SET_VOUCHERS_DATA: (state, payload) => {
    state.vouchers_data = payload;
  },
  SET_NEW_SEAT_LAYOUT: (state, payload) => {
    state.newSeatLayoutArrayState = payload;
  }
};

const actions = {
  setOfferCode: async ({ dispatch, commit, state }, payload) => {
    let offer = null;
    state.OffersList.map(x => {
      if (state.promocode == x.promo_code) {
        offer = x;
      }
    });
    if (offer == null) {
      Vue.toasted.show("Please enter a valid promo code");
    } else {
      await dispatch("applyOffersHandler", {
        offerFor: "offersAndPromotions",
        offer: offer
      });
    }
  },
  fetchCustomerCategoriesList: async ({ dispatch, commit, state }, payload) => {
    MovieService.GetCustomerCategories()
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          if (data.Records.length > 0) {
            commit("SET_OFFERS_CATEGORIES_LIST", data.Records);
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on fetchCustomerCategoriesList", error);
      })
      .finally(() => {
        // setTimeout(() => loader.hide(), 1000);
      });
  },
  onEnterPromoCodes: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_ENTER_PROMO_CODE", payload);
  },
  applyOffersHandler: async ({ dispatch, commit, state }, payload) => {
    const { offer, offerFor } = payload;

    if (payload.offerFor === "offersAndPromotions") {
      if (offer.offer_type_id == 6) {
        await commit("SET_SELECTED_OFFERS", {
          offerFor: payload.offerFor,
          offer: offer
        });
        await commit("CALCULATE_OFFER_PRICE", {
          offer,
          offerFor
        });

      } else if (offer.offer_type_id == 4) {
        await commit("SET_SELECTED_OFFERS", {
          offerFor: payload.offerFor,
          offer: offer
        });
        await commit("CALCULATE_OFFER_PRICE", {
          offer,
          offerFor
        });
      } else {
        if (
          (offer.oc_is_combo == "Y" && offer.oc_is_combo_with_fnb == "Y") ||
          (offer.oc_is_combo == "Y" && offer.oc_is_combo_free == "Y")
        ) {
          Vue.toasted.show("Offer is applicable on Fnb");
          await dispatch("onResetOffersAndPrice");
        } else {

          if (state.seatsSelected.length >= offer.oc_buy_no_of_ticket + offer.oc_get_free_ticket) {
            if (
              offer.offer_applicable_on_gross_amount == "Y" &&
              offer.oc_min_ticket_price &&
              parseFloat(state.totalTicketPrice) >= parseFloat(offer.oc_min_ticket_price)
            ) {
              //apply offer
              await commit("SET_SELECTED_OFFERS", payload);
              await commit("CALCULATE_OFFER_PRICE", {
                offer,
                offerFor
              });

              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
            } else if (
              offer.offer_applicable_on_net_amount == "Y" &&
              offer.oc_min_ticket_price &&
              parseFloat(state.totalPrice) >= parseFloat(offer.oc_min_ticket_price)
            ) {
              //apply offer
              await commit("SET_SELECTED_OFFERS", payload);
              await commit("CALCULATE_OFFER_PRICE", {
                offer,
                offerFor
              });
              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
            } else if (offer.offer_applicable_on_gross_amount == "Y") {
              //apply offer
              await commit("SET_SELECTED_OFFERS", payload);
              await commit("CALCULATE_OFFER_PRICE", {
                offer,
                offerFor
              });

              vmVue.$root.$emit("bv::hide::modal", "pos-applicable-offers");
            }
          } else {
            Vue.toasted.show(
              "Please select atleast " +
              (offer.oc_buy_no_of_ticket + offer.oc_get_free_ticket) +
              " ticket(s)"
            );
            await dispatch("onResetOffersAndPrice");
          }
        }
      }
    } else if (offerFor === "voucher") {
      await commit("SET_SELECTED_OFFERS", {
        offerFor: payload.offerFor,
        offer: offer
      });

      await commit("CALCULATE_OFFER_PRICE", {
        offer,
        offerFor
      });
    }
  },
  onResetOffersAndPrice: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("ON_RESET_SELECTET_OFFER_AND_PRICE");
  },
  RESERVE_SEATS: async ({ commit, state, dispatch }, { ...payload }) => {
    let seats = payload.seat_layout_id.map(x => x.sl_id);
    let SeatTypeId = payload.seat_layout_id.map(x => x.sst_id);
    let newSeatLayoutArray = [];
    let rateCardGroup = [];
    payload.seatGroup.map(seat_g => {
      seat_g.rate_card_group.map(rg => {
        let findIndex32 = rateCardGroup.findIndex(newrg => {
          return newrg.tt_id == rg.tt_id;
        });

        if (findIndex32 >= 0) {
          rateCardGroup[findIndex32]["count"] =
            rateCardGroup[findIndex32]["count"] + rg.totalSeatSelected;
        } else {
          let objRateCard = {
            tt_id: rg.tt_id,
            tt_name: rg.tt_name.trim(),
            count: rg.totalSeatSelected
          };
          rateCardGroup.push(objRateCard);
        }

        for (let i = 0; i < rg.totalSeatSelected; i++) {
          let obj = {
            rate_card_id: rg.rate_card_id,
            tt_id: rg.tt_id,
            rc_g_id: rg.rc_g_id,
            rcg_c_id: rg.rcg_c_id,
            tt_name: rg.tt_name,
            seat_type_id: seat_g.sst_id,
            status: false
          };
          newSeatLayoutArray.push(obj);
        }
      });
    });
    if (seats.length > 0) {
      let login_details = store.getters.login_details;
      let cust_id =
        login_details && login_details.length > 0 && login_details[0].cust_id
          ? login_details[0].cust_id
          : null;
      let guest_user_id = localStorage.getItem("guest_user_id")
        ? localStorage.getItem("guest_user_id")
        : null;
      await MainServices.ReserveSeats({
        groupRateCard: true,
        seat_layout_id: seats,
        schedule_show_id: payload.schedule_show_id,
        newSeatLayout: newSeatLayoutArray,
        seat_type_id: SeatTypeId,
        reservation_id: payload.reservation_id,
        cust_id,
        aggregator_cinema: payload.aggregator_cinema,
        guest_user_id: guest_user_id
      })
        .then(response => {
          const { data } = response;
          if (data.status) {
            commit("ON_RESERVE_SEATS", payload.reservation_id);
          } else {
            state.seatsSelected = [];
            commit("NUMBER_OF_SEATS", state.totalNumberOfSeats);
          }
        })
        .catch(err => {
          Vue.toasted.show("Catch error in reserve seat");
        });
    } else {
      Vue.toasted.show("Please select at least one seat");
    }
  },

  RESERVE_SEATS_CREATE_SHOW: async ({ commit, state, dispatch }, { ...payload }) => {
    let seats = payload.seat_layout_id.map(x => x.sl_id);
    let SeatTypeId = payload.seat_layout_id.map(x => x.sst_id);
    let newSeatLayoutArray = [];
    let rateCardGroup = [];
    payload.seatGroup.map(seat_g => {
      seat_g.rate_card_group.map(rg => {
        let findIndex32 = rateCardGroup.findIndex(newrg => {
          return newrg.tt_id == rg.tt_id;
        });

        if (findIndex32 >= 0) {
          rateCardGroup[findIndex32]["count"] =
            rateCardGroup[findIndex32]["count"] + rg.totalSeatSelected;
        } else {
          let objRateCard = {
            tt_id: rg.tt_id,
            tt_name: rg.tt_name.trim(),
            count: rg.totalSeatSelected
          };
          rateCardGroup.push(objRateCard);
        }

        for (let i = 0; i < rg.totalSeatSelected; i++) {
          let obj = {
            rate_card_id: rg.rate_card_id,
            tt_id: rg.tt_id,
            rc_g_id: rg.rc_g_id,
            rcg_c_id: rg.rcg_c_id,
            tt_name: rg.tt_name,
            seat_type_id: seat_g.sst_id,
            status: false
          };
          newSeatLayoutArray.push(obj);
        }
      });
    });

    if (seats.length > 0) {
      let login_details = store.getters.login_details;
      let cust_id =
        login_details && login_details.length > 0 && login_details[0].cust_id
          ? login_details[0].cust_id
          : null;
      let guest_user_id = localStorage.getItem("guest_user_id")
        ? localStorage.getItem("guest_user_id")
        : null;
      await MainServices.ReserveSeatsCreateShow({
        groupRateCard: true,
        seat_layout_id: seats,
        newSeatLayout: newSeatLayoutArray,
        seat_type_id: SeatTypeId,
        cinema_reservation_id: payload.cinema_reservation_id,
        cust_id,
        cinema_id: payload.cinema_id,
        aggregator_cinema: payload.aggregator_cinema,
        guest_user_id: guest_user_id,
        "mycinema_booking_type_id": payload.mycinema_booking_type_id,
        "mycinema_ss_d_id": payload.mycinema_ss_d_id
      })
        .then(response => {
          const { data } = response;
          if (data.status) {
            commit("ON_RESERVE_SEATS", payload.reservation_id);
          } else {
            state.seatsSelected = [];
            commit("NUMBER_OF_SEATS", state.totalNumberOfSeats);
          }
        })
        .catch(err => {
          Vue.toasted.show("Catch error in reserve seat");
        });
    } else {
      Vue.toasted.show("Please select at least one seat");
    }
  },


  seatHandler: async (context, payload) => {
    if (state.isMultiSelectAllowed) {
      await context.commit("SELECT_SEAT_HANDLDER", payload);
    }
    let newPayload = {
      seat: payload.seat,
      seatIndex: payload.seatIndex,
      rowIndex: payload.rowIndex,
      classIndex: payload.type
    };
    await context.commit("SELECTED_SEATS", newPayload);
  },
  seatPrice: ({ commit, state }) => {
    let totalPrice = 0;
    let totalGrossPrice = 0;
    state.seatsSelected.map(x => {
      totalPrice += x.seat_net_price;
      totalGrossPrice += x.seat_price;
    });
    commit("TOTAL_PRICE", { totalPrice, totalGrossPrice });
  },

  SelectNumberOfSeats: (context, payload) => {
    context.commit("NUMBER_OF_SEATS", payload);
  },

  getSeats: async ({ commit }, payload) => {

    let data = {};
    let login_details = store.getters.login_details;

    let cust_id =
      login_details && login_details.length > 0 && login_details[0].cust_id
        ? login_details[0].cust_id
        : null;

    let guest_user_id = localStorage.getItem("guest_user_id")
      ? localStorage.getItem("guest_user_id")
      : null;

    let seats;

    if (payload.vista_schedule_id) {
      seats = await vistaServices.getSeatLayout({ vista_schedule_id: payload.vista_schedule_id })
    }
    else if (payload.rts_performance_id) {
      seats = await rtsServices.getSeatLayout({ rts_performance_id: payload.rts_performance_id })
    }
    else if (payload.ss_id) {
      seats = await MainServices.getSeatLayout({
        screen_id: payload.screen_id,
        ss_id: payload.ss_id,
        md_id: payload.md_id,
      });
    } else {
      seats = await MainServices.getSeatLayoutCreateScreen({
        mycinema_ss_d_id: payload.mycinema_ss_d_id,
      });
    }
    if (seats.data.status) {
      data.seats = seats.data;
      if (seats && seats.status) {
        commit("SET_SEATS", data);
      } else {
        Vue.toasted.show(data.message || "Please try later");
      }
    }
  },

  getLangFilter({ state, commit }, payload) {
    commit("RESET_LANG_MF");
    for (let i in payload) {
      if (state.langfilter.indexOf(payload[i].lang_name) == -1) {
        commit("GET_LANG_FILTER", payload[i].lang_name);
      }
      if (state.mf_filter.indexOf(payload[i].mf_name) == -1) {
        commit("GET_MF_FILTER", payload[i].mf_name);
      }
    }
  },

  onGetMovieDates: ({ commit }, { movie_id }) => {
    commit("SET_ARE_SHOWS_AVAILABLE", true);
    let guest_user_id = localStorage.getItem("guest_user_id")
      ? localStorage.getItem("guest_user_id")
      : null;
    let login_details = store.getters.login_details;
    let cust_id =
      login_details && login_details.length > 0 && login_details[0].cust_id
        ? login_details[0].cust_id
        : null;
    return MovieService.GetMovieDates({ movie_id, guest_user_id, cust_id })
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {

            commit("SET_DATES", data.Records);
          } else {
            commit("RESET_DATES");

            Vue.toasted.show("No Shows Scheduled");
            commit("SET_ARE_SHOWS_AVAILABLE", false);
          }
        } else {
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },
  onGetMovieShowDates: ({ commit }, { movie_id, cinema_id }) => {
    commit("SET_MOVIE_DATES", []);
    commit("SET_ARE_SHOWS_AVAILABLE", true);
    return MovieService.GetMovieDates({ movie_id, cinema_id })
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            const dates = [
              ...new Set(
                data.Records.map(date => (date = moment(date.ss_start_date).format("DD-MM-YYYY")))
              )
            ];

            commit("SET_MOVIE_DATES", dates);
          } else {
            Vue.toasted.show("No Shows Scheduled");
            commit("SET_ARE_SHOWS_AVAILABLE", false);
          }
        } else {
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },

  onGetMovieDetails: ({ commit, state, dispatch }, payload) => {
    let content_lang_id = payload.content_lang_id || 1;
    let guest_user_id = localStorage.getItem("guest_user_id") || null;
    commit("SET_ON_MOVIE_DETAILS_ID", { movie_id: payload.movie_id });
    return MovieService.GetMovieDetails({ content_lang_id, guest_user_id, ...payload })
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            await commit(
              "SET_ON_MOVIE_DETAILS",
              { movie_id: payload.movie_id, ...data.Records[0] } || {}
            );
            await dispatch("getSeoData");
          } else {
            Vue.toasted.show("No Records Found");
          }
        } else {
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },
  onResetSeatLayout: ({ commit, state, dispatch }, payload) => {
    commit("RESET_SEAT_DATA");
  },
  onSetDefaultFilter: async ({ commit, state, dispatch }, payload) => {
    await commit("RESET_ALL");
    await commit("SET_ON_MOVIE_FILTERS", payload);
    await dispatch("onGetMovieFormat", {});
    if (
      state.selectedMovieFilter.showDate &&
      state.selectedMovieFilter.showFormat &&
      typeof state.selectedMovieFilter.showFormat === "object" &&
      state.selectedMovieFilter.showFormat !== "ALL FORMATS"
    ) {
      await dispatch("onGetMoviesSchedules", {});
    }
  },
  onGetMovieFormat: async ({ commit, state, dispatch }, payload) => {
    MovieService.GetMovieFilters({
      movie_id: state.movieDetailsObject.movie_id
    })
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            await commit("SET_ON_MOVIE_FORMAT", data.Records || []);
            dispatch("getLangFilter", data.Records);
          }
          if (
            state.selectedMovieFilter.showDate &&
            state.selectedMovieFilter.showFormat == "ALL FORMATS"
          ) {
            await dispatch("onGetAllMoviesSchedules", {});
          }
        } else {
        }
      })
      .catch(error => {
        console.log("error", error);
      });
  },
  onGetMoviesSchedulesOld: async ({ commit, state, dispatch }, payload) => {
    MovieService.GetSchedules({
      md_id: state.selectedMovieFilter.showFormat.md_id,
      date: state.selectedMovieFilter.showDate
    })
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          commit("SET_ON_MOVIE_SCHEDULE", data.Records);
        } else {
        }
      })
      .catch(error => {
        //Vue.toasted.show(error);
        console.log("error", error);
      });
  },
  onGetMoviesSchedules: ({ commit, state, dispatch }, payload) => {
    let loader = Vue.$loading.show();
    return MovieService.GetSchedules({
      md_id: state.selectedMovieFilter.showFormat.md_id,
      date: state.selectedMovieFilter.showDate
    })
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          commit("SET_ON_MOVIE_SCHEDULE", data.Records);
        } else {
        }
      })
      .catch(error => {
        console.log("error", error);
      })
      .finally(err => loader.hide());
  },
  onGetAllMoviesSchedulesOld: async ({ commit, state, dispatch }, payload) => {
    let FinalArray = [];
    let index = 0;
    for (let i = 0; i <= state.movieDetailsFormatList.length - 1; i++) {
      if (i) {
        index = index + 1;
      }
      MovieService.GetMovieSchedules({
        md_id: state.movieDetailsFormatList[i].md_id,
        date: state.selectedMovieFilter.showDate
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              FinalArray = FinalArray.concat(data.Records);
            }
          } else {
          }

          if (index === state.movieDetailsFormatList.length - 1) {
            commit("SET_ON_MOVIE_SCHEDULE", FinalArray);
          }
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  onGetAllMoviesSchedules: async ({ commit, state, dispatch }, payload) => {
    let loader = Vue.$loading.show();
    let FinalArray = [];
    let index = 0;
    for (let i = 0; i <= state.movieDetailsFormatList.length - 1; i++) {
      if (i) {
        index = index + 1;
      }
      MovieService.GetSchedules({
        md_id: state.movieDetailsFormatList[i].md_id,
        date: state.selectedMovieFilter.showDate
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              FinalArray = FinalArray.concat(data.Records);
            }
          } else {
          }

          if (index === state.movieDetailsFormatList.length - 1) {
            commit("SET_ON_MOVIE_SCHEDULE", FinalArray);
          }
        })
        .catch(error => {
        })
        .finally(() => loader.hide());
    }
  },
  getScreen: ({ commit, state }) => {
    MovieService.GetScreen({ screen_id: state.seatsSelected[0].screen_id })
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records && data.Records.length > 0) {
            commit("SET_SCREEN", data.Records[0]);
          } else {
          }
        } else {
        }
      })
      .catch(error => {
        console.log("error", error);
      });
  },
  resetSelectedSeats({ commit }) { },
  getAdditionalCharges: async ({ commit, state }, { ...payload }) => {
    const { data } = await MovieService.GetAdditionalCharges({
      selectedSeats: state.seatsSelected,
      isGroupCardExist: true,
      showDetails: state.schedule_details_obj,
      newSeatLayout: payload.newSeatLayoutArray
    });
    commit("SET_ADDITIONAL_CHARGES", data);
  },
  getOffers({ state, commit }) {
    MovieService.GetOffers({
      cinema_id: state.schedule_details_obj.cine_id,
      movie_details_id: state.schedule_details_obj.md_id,
      screen_id: state.schedule_details_obj.screen_id,
      seat_type_id: state.seatsSelected[0].screen_seat_type_id,
      show_date_time: moment.unix(state.schedule_details_obj.ss_start_date_time / 1000).format()
    })
      .then(response => {
        const { data } = response;
        if (data.status) {
          if (data.Records) {
            commit("SET_OFFERS_LIST", data.Records);
          }
        } else {
        }
      })
      .catch(err => {
        Vue.toasted.show("Catch error in offers");
      });
  },
  removeCoupon({ state, commit }) {
    commit("REMOVE_PROMO_CODE");
  },
  getSeoData: async function ({ state, commit }) {
    MovieService.GetSeo({ seo_id: 2 })
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          let seoFinal = {};
          let seo_obj = {
            seo_meta_title: data.Records[0].seo_meta_title,
            seo_meta_description: data.Records[0].seo_meta_description,
            seo_meta_keywords: data.Records[0].seo_meta_keywords,
            og_type: data.Records[0].og_type,
            og_site: data.Records[0].og_site
          };
          seoCreate(
            seo_obj,
            state.movieDetailsObject.mc_title,
            state.langfilter,
            state.movieDetailsObject.genre
          )
            .then(async response => {
              seoFinal = await response;
              commit("SET_SEO_DATA", seoFinal);
            })
            .catch(err => {
              console.log("err :>> ", err);
            });

        } else {
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },
  getScheduleDetails: ({ commit, dispatch, state }, ss_id) => {
    let savedLang = store.getters.getCurrentLang;
    let content_lang_id = savedLang ? savedLang.lang_id : 1;
    return MovieService.GetScheduleDetails({ ss_id: ss_id, content_lang_id })
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            await commit("SET_SCHEDULE_DETAILS_OBJ", data.Records[0] || {});
            await dispatch("getSeats", {
              md_id: state.schedule_details_obj.md_id,
              screen_id: state.schedule_details_obj.screen_id,
              ss_id: state.schedule_details_obj.ss_id
            });
            commit("SET_MOVIE_ID", state.schedule_details_obj.movie_id);
            await dispatch("onGetMovieDetails", {
              movie_id: state.schedule_details_obj.movie_id,
              cust_id: null,
              content_lang_id
            });
            await dispatch("getAllShowDates");
          }
        } else {
        }
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },
  setScheduleObj: ({ commit }, payload) => {
    commit("SET_SCHEDULE_OBJ", payload);
  },
  onGetAllMoviesSchedulesSeatPage: async ({ commit, state, dispatch }, payload) => {
    commit("RESET_MOVIE_DETAILS_SCHEDULE_LIST_NEW");
    let FinalArray = [];
    let index = 0;

    let loader = Vue.$loading.show();

    MovieService.GetSchedules({ md_id: payload.md_id, date: payload.showDate })
      .then(response => {
        loader.hide();
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            FinalArray = FinalArray.concat(data.Records);
          }
        } else {
          Vue.toasted.show(data.message);
        }

        commit("SET_ON_MOVIE_SCHEDULE", FinalArray);
      })
      .catch(error => {
        Vue.toasted.show(error);
      });
  },
  onSetCompleteRateCard: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_COMPLETE_RATE_CARD", payload.status);
    await commit("SET_SEAT_GROUP_ALL", payload.seatGroup);
  },
  onSetCompleteNewTotalAmount: async ({ dispatch, commit, state }, payload) => {
    await commit("SET_TOTAL_BOX_OFFICE_AMOUNT", payload);
  },
  getVouchersList: async ({ commit, state }, payload) => {
    let guest_user_id = localStorage.getItem("guest_user_id")
      ? localStorage.getItem("guest_user_id")
      : null;
    let login_details = store.getters.login_details;
    let cust_id =
      login_details && login_details.length > 0 && login_details[0].cust_id
        ? login_details[0].cust_id
        : null;
    const s = {
      cinema_id: state.schedule_details_obj.cine_id,
      movie_details_id: state.schedule_details_obj.movie_details_id,
      screen_id: state.schedule_details_obj.screen_id,
      seat_type_id: payload.seat.sst_id,
      show_date_time: state.schedule_details_obj.ss_start_date_time,
      aggregator_cinema_id: state.schedule_details_obj.cine_id,
      selectSeats: state.seatsSelected,
      guest_user_id: guest_user_id,
      cust_id: cust_id
    };
    return MovieService.GetVouchersList(s)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          commit("SET_VOUCHERS_DATA", data.Records);
        }
      })
      .catch(err => {
        Vue.toasted.show(err.message);
      });
  },
  validateVoucher: async ({ commit, state, dispatch }, payload) => {
    const { voucher_code, successCallback } = payload;
    let voucherObj = state.vouchers_data.find(voucher => voucher.voucher_code === voucher_code);
    if (voucherObj) {
      return MovieService.ValidateVoucherCode({
        vouchercode: voucher_code,
        voucher_title: voucherObj.voucher_title
      })
        .then(resp => {
          const { data } = resp;
          if (data && data.status) {
            Vue.toasted.show("Voucher applied!");
            dispatch("applyOffersHandler", {
              offerFor: "voucher",
              offer: voucherObj
            });
            successCallback ? successCallback() : null;
          } else {
            Vue.toasted.show(data.message);
          }
        })
        .catch(err => {
          Vue.toasted.show(err.message);
        });
    } else {
      Vue.toasted.show("Invalid voucher code.");
    }
  }
};

//
const getters = {
  getMovieDetailsObject: state => state.movieDetailsObject,
  isMultiSelectAllowed: state => state.isMultiSelectAllowed,
  getMovieDetailsSelectedFilter: state => state.selectedMovieFilter,
  getMovieDetailsFormatList: state => state.movieDetailsFormatList,
  getMovieDetailsScheduleList: state => state.movieDetailsScheduleList,
  getOP: state => state.output,
  getLang: state => state.langfilter,
  getMf: state => state.mf_filter,
  getSingleMovieDates: state => state.singleMovieDates,
  getSeatLayout: state => state.seatLayout,
  seatType: state => state.seatLayoutData,
  seatsSelected: state => state.seatsSelected,
  SELECTED_SEATS: state => state.seatsSelected,
  totalNumberOfSeats: state => state.totalNumberOfSeats,
  screen: state => state.screen,
  totalPrice: state => state.totalPrice,
  NET_AMOUNT: state => state.totalPrice,
  reservationId: state => state.reservationId,
  additionalCharges: state => state.additionalCharges,
  getselectedDate: state => state.selectedDate,
  getOffersCollection: state => state.OffersList,
  promoCode: state => state.promocode,
  totalTicketPrice: state => state.totalTicketPrice,
  TOTAL_AMOUNT: state => state.totalTicketPrice,
  offerPrice: state => state.offerPrice,
  offerSet: state => state.offerSet,
  totalGrossPrice: state => state.totalGrossPrice,
  seoData: state => state.seoData,
  selectedOffers: state => state.selectedOffers,
  schedule_details_obj: state => state.schedule_details_obj,
  offerFor: state => state.offerFor,
  SELECTED_SEATS: state => state.seatsSelected,
  getNetAmount: state => state.netAmount,
  getMovieDates: state => state.movie_dates,
  areShowsAvailable: state => state.are_shows_available,
  getMovieId: state => state.movie_id
  // applied_voucher: state => state.applied_voucher
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/MovieDetails.js